import React, { useCallback, useState } from 'react';
import { CheckInSystem } from './CheckInSystem';
import { EnterPassword } from './EnterPassword';
import { ForgotPassword } from './ForgotPassword';
import { Registration } from './Registration';
import { EmailSent } from './EmailSent';

interface IProps {
  hideGuestBtn?: boolean;
  initPhone?: string;
  initEmail?: string;
  isDialog?: boolean;
}

export type TAuthTabs =
  | 'CheckInSystem'
  | 'EnterPassword'
  | 'ForgotPassword'
  | 'Registration'
  | 'EmailSent';

export const AuthTabs: React.FC<IProps> = ({
  hideGuestBtn,
  initPhone,
  initEmail,
  isDialog,
}) => {
  const [tab, setTab] = useState<TAuthTabs>('CheckInSystem');
  const [tabProps, setTabProps] = useState<any>({});

  const authTabSwitcher = useCallback(() => {
    switch (tab) {
      case 'CheckInSystem':
        return (
          <CheckInSystem
            initEmail={initEmail}
            hideGuestBtn={hideGuestBtn}
            changeAuthTab={changeAuthTab}
            isDialog={isDialog}
            {...tabProps}
          />
        );
      case 'EnterPassword':
        return <EnterPassword changeAuthTab={changeAuthTab} {...tabProps} />;
      case 'ForgotPassword':
        return <ForgotPassword changeAuthTab={changeAuthTab} {...tabProps} />;
      case 'Registration':
        return (
          <Registration isDialog={isDialog} changeAuthTab={changeAuthTab} {...tabProps} />
        );
      case 'EmailSent':
        return <EmailSent changeAuthTab={changeAuthTab} {...tabProps} />;
      default:
        return <></>;
    }
  }, [tab]);

  const changeAuthTab = useCallback((newTab: TAuthTabs, props: any = {}) => {
    setTab(newTab);
    setTabProps(props);
  }, []);

  return authTabSwitcher();
};
